import {
  TranslationKeys,
  useTranslation,
} from "@/hooks/useTranslation/useTranslation"

/**
 * Empty state shown in the detail panel when no row is selected. Each tab
 * passes the key naming its own object ("Wähle einen Artikel aus ..."); the
 * generic body is the fallback.
 */
export function EntityEmptyDetail({
  body = "MC_MD_EMPTY_SELECT_BODY",
}: {
  body?: TranslationKeys
}) {
  const { translate } = useTranslation()

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-8 text-center">
      <div className="text-sm font-medium text-white">
        {translate("MC_MD_EMPTY_SELECT_TITLE")}
      </div>
      <div className="text-xs text-grey5">{translate(body)}</div>
    </div>
  )
}
